export enum SettingsType {
  ECONOMY = "ECONOMY",
  STANDARD = "STANDARD",
  PRIORITY = "PRIORITY",
  RUSH = "RUSH",
  AFTER_HOURS = "AFTER_HOURS"
}